// Shared types for itms-qc. Anything used by 2+ workspaces (api, portal,
// scheduler) lives here. Anything used by exactly one workspace stays in
// that workspace.
// === Permissions (wise-iam keys) ===
//
// Exactly TWO permission keys (owner decision 2026-06-10, supersedes the
// original qc.triage/qc.admin split in the build spec):
//   qc.use    — sign in, view all cases, file cases/incidents, add notes.
//               Every authenticated WISE user holds this via all_employees.
//   qc.manage — close/reopen/archive view, change status/priority/assignment,
//               merge/mark duplicate, module + submodule admin. Held by the
//               qc_developer role (per-person grants) and platform_admin.
export const QC_PERMISSION_USE = 'qc.use';
export const QC_PERMISSION_MANAGE = 'qc.manage';
// Actor id stamped on system-generated qc_case_activity rows (e.g. the
// nightly archive job). Matches the platform-wide system actor convention.
export const QC_SYSTEM_ACTOR_ID = '00000000-0000-0000-0000-000000000000';
// === Enums ===
export const QC_CASE_TYPES = ['bug', 'feature_request'];
export const QC_CASE_PRIORITIES = ['low', 'medium', 'high'];
export const QC_CASE_STATUSES = [
    'new',
    'triaged',
    // The explicit decision state for feature requests: "we agree — on the
    // roadmap" (migration 011). Sits between the review (new/triaged) and the
    // build (in_progress). Non-terminal.
    'accepted',
    'in_progress',
    'fixed',
    'closed',
    'wont_do',
    'duplicate',
];
// Terminal statuses: eligible for auto-archive 30 days after closed_at.
// `fixed` is NOT terminal — it requires verification before close.
export const QC_TERMINAL_STATUSES = ['closed', 'wont_do', 'duplicate'];
export const QC_ENVIRONMENTS = ['dev', 'test', 'prod'];
/** Cap on attachments per report (incident) or note — enforced client and server side. */
export const QC_MAX_ATTACHMENTS = 10;
export const QC_NOTE_VISIBILITIES = ['public', 'internal'];
// === /api/qc/suggest/feature-intake ===
// Guided AI conversation that helps a requestor flesh out a feature request
// before filing. Stateless and turn-based: the client posts the running
// transcript each turn; the server replies with the next question, the final
// synthesis, or 'disabled' (AI unconfigured → client falls back to free text).
export const QC_FEATURE_INTAKE_MAX_QUESTIONS = 4;
// Compose the structured synthesis into the case-description markdown the
// requestor reviews and edits. Deterministic (not AI-formatted) so the shape
// is stable. Empty sections are omitted.
export function composeFeatureDescription(s) {
    const sections = [
        ['Problem', s.problem],
        ['Today’s workaround', s.currentWorkaround],
        ['Desired outcome', s.desiredOutcome],
        ['Example', s.example],
        ['Who’s affected / how often', s.impact],
    ];
    const parts = sections
        .filter(([, v]) => v && v.trim())
        .map(([h, v]) => `**${h}**\n${v.trim()}`);
    const criteria = s.acceptanceCriteria.filter((c) => c && c.trim());
    if (criteria.length) {
        parts.push(`**Acceptance criteria (draft)**\n${criteria.map((c) => `- ${c.trim()}`).join('\n')}`);
    }
    return parts.join('\n\n');
}
// === QC Audits (migration 013) ===
// Proactive checklist verification of a module's feature inventory.
// Failing an item auto-files a linked QC case (bug lane).
export const QC_AUDIT_RESULTS = ['pass', 'fail', 'blocked'];
export const QC_AUDIT_RUN_STATUSES = ['in_progress', 'completed', 'abandoned'];
//# sourceMappingURL=index.js.map